import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { ComponentProps } from 'react';

type HomepageSectionProps = ComponentProps<'section'> & {
  containerClassName?: string;
};

export function HomepageSection({
  className,
  containerClassName,
  children,
  ...props
}: HomepageSectionProps) {
  return (
    <section className={cn('custom-section py-[52px] min-[641px]:py-20', className)} {...props}>
      <div className={cn('custom-container custom-container--wide', containerClassName)}>
        {children}
      </div>
    </section>
  );
}
